import { BaseTooltip, BaseOverlay } from './BaseTooltip';
import * as ReminderTooltips from './ReminderTooltips';
import * as KeyboardShortcutTooltips from './KeyboardShortcutTooltips';

export const Tooltip = BaseTooltip;
export const Overlay = BaseOverlay;

export const SetReminderTooltip = ReminderTooltips.SetReminder;
export const EditReminderTooltip = ReminderTooltips.EditReminder;
export const DeleteReminderTooltip = ReminderTooltips.DeleteReminder;
export const AddNoteToReminderTooltip = ReminderTooltips.AddNoteToReminder;

export const Key = KeyboardShortcutTooltips.Key;
export const KeyWithTrigger = KeyboardShortcutTooltips.KeyWithTrigger;
export const KeyboardShortcut = KeyboardShortcutTooltips.KeyboardShortcut;
